import { useMutation } from '@tanstack/react-query';
import type { CreateExportRequestParams } from '@/features/agent/export_requests/types/ExportRequest';

export default function usePostExportRequests() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: CreateExportRequestParams) => {
      const response = await fetch('/agent/api/export_requests', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(params),
      });
      if (!response.ok) {
        throw new Error('Failed to create export request');
      }
      return await response.json();
    },
  });
}
